import { render } from "./ToggleButtons.vue?vue&type=template&id=dd58b7cc"
import script from "./ToggleButtons.vue?vue&type=script&lang=js"
export * from "./ToggleButtons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__